import { useState, useCallback, useMemo } from 'react'

/**
 * Logic around selection flashcards from a list.
 */
export function useFlashcardSelection() {
  const [selection, setSelection] = useState({})

  const refreshSelectionWith = useCallback(flashcards => {
    setSelection(prev => {
      return flashcards.reduce((acc, fc) => {
        acc[fc.id] = prev[fc.id] || false
        return acc
      }, {})
    })
  }, [])

  const toggleSelection = id => {
    setSelection(prev => {
      return { ...prev, [id]: !prev[id] }
    })
  }

  return {
    selection,
    checkSelection: (state, id) => Boolean(state[id]),
    refreshSelectionWith,
    toggleSelection,
  }
}

export function useFlashcardSelectionSize(selection) {
  return useMemo(
    () => Object.values(selection).reduce((count, v) => count + (v ? 1 : 0), 0),
    [selection]
  )
}
